<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="2" class="py-2">
                <span>
                  <b>Investigaors / Partners</b>
                </span>
              </b-col>
              <!-- <b-col cols="12" md="3" class="py-2" v-if="tableType">
                <b-dropdown
                  variant="outline-primary"
                  size="sm"
                  id="dropdown-1"
                  :text="tableType.name"
                >
                  <b-dropdown-item
                    v-for="(item,i) in tableTypes"
                    :key="i"
                    @click="getData(item)"
                  >{{item.name}}</b-dropdown-item>
                </b-dropdown>
              </b-col>-->
              <!-- <b-col cols="12" md="3" class="py-2">
                <b-form @submit.prevent="getSearch">
                  <b-row>
                    <b-col cols="8">
                      <b-form-input
                        list="searchData"
                        v-model="searchKey"
                        placeholder="Search"
                        size="sm"
                      ></b-form-input>
                      <datalist id="searchData">
                        <option v-for="(item,i) in searchData" :key="i">{{item}}</option>
                      </datalist>
                    </b-col>
                    <b-col cols="4">
                      <b-button variant="outline-primary" size="sm" @click="getSearch">Search</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-col> v-if="userRole=='SuperUser' || userRole=='Manager'"-->
              <b-col cols="12" md="8" class="py-2"></b-col>
              <b-col cols="12" md="2">
                <!-- <b-button variant="outline-primary" size="sm" router-link to="/AddUser">Add New User</b-button> -->
                <b-button
                  class="buttonlink"
                  to="/AddUser"
                  v-b-modal.modal-lg
                  variant="link"
                  style="color:primary"
                >
                  <b>+ Add New User</b>
                </b-button>
              </b-col>
            </b-row>
          </template>
          <b-table
            :hover="true"
            :striped="true"
            :bordered="false"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="users"
            :fields="fields"
            @row-clicked="rowClicked"
          >
            <template v-slot:cell(name)="data">
              <span v-if="data.item.name">{{data.item.name}}</span>
            </template>
            <template v-slot:cell(phone)="data">
              <span v-if="data.item.phone">{{data.item.phone}}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:cell(email)="data">
              <span v-if="data.item.email">{{data.item.email}}</span>
              <span v-else>-</span>
            </template>
            <template v-slot:cell(role)="data">
              <span v-if="data.item.role == 'user' && data.item.usertype == 0">Investigator</span>
              <span v-else-if="data.item.role == 'user' && data.item.usertype == 1">Partner</span>
              <span v-else>-</span>
            </template>
          </b-table>
          <nav>
            <b-pagination
              size="sm"
              :total-rows="totalData"
              :per-page="perPage"
              v-model="currentPage"
              prev-text="Prev"
              next-text="Next"
              @change="nextPage"
            />
          </nav>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import store from "../../store";
import axios from "axios";
export default {
  data() {
    return {
      users: [],
      fields: [
        // { key: "accountcreateat", label: "Created on", sortable: false },
        { key: "name", label: "Name", sortable: false },
        // { key: "username", label: "Username", sortable: false },
        { key: "phone", label: "Phone", sortable: false },
        { key: "email", label: "Email", sortable: false },
        { key: "role", label: "User Type", sortable: false },

        // { key: "status", label: "Status", sortable: false },
        // { key: "lastactiontime", label: "Last Action Time", sortable: false },
      ],
      totalData: 0,
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
      tableTypes: [
        { name: "All Users", role: "", route: "/users/list" },
        // { name: "Super User", role: "SuperUser",route:'/user/allUsers' },
        { name: "Admin", role: "Admin", route: "/admins/list" },
      ],
      tableType: null,
      searchKey: null,
      searchData: [],
      userRole: localStorage.getItem("role"),
    };
  },
  computed: {
    getStore() {
      return store.state.users;
    },
  },
  mounted() {
    this.tableType = this.tableTypes[0];
    this.getData(this.tableType);
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.getData(this.tableType);
    },
    getData(item) {
      if (item != this.tableType) this.currentPage = 1;
      this.tableType = item;
      this.appLoading = true;
      axios({
        url: item.route,
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          count: this.perPage,
          page: this.currentPage,
          role: item.role,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.users = response.data.data;
          this.totalData = response.data.count;
          this.searchData = response.data.allusers;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getSearch() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/search",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.perPage,
          page: this.currentPage,
          key: this.searchKey,
          role: this.tableType.role,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.users = response.data.data;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
    rowClicked(item) {
      this.$router.push("/Users/" + item._id);
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
